import { CoreProps, FluidImage, ResponsiveImage, useScreenClass } from "@vp/swan";
import React from "react";
import { ImageSrcProps } from "../../types";
import { getProcessedImageSourceSet } from "../../utils";

// Pass isFluidImage = false to use native image tag
export type IImage = {
  imageSrc: ImageSrcProps[];
  altOverride?: string;
  imageOverrideProps?: Omit<CoreProps<JSX.IntrinsicElements["img"]>, "alt">;
  isFluidImage?: boolean;
  testId?: string;
  isBannerLogo?: boolean;
  isDoubleBanner?: boolean;
};

export const Image: React.FC<IImage> = ({
  imageSrc,
  altOverride,
  imageOverrideProps,
  isFluidImage = true,
  testId,
  isBannerLogo = false,
  isDoubleBanner = false,
}) => {
  const processedImageSrc = getProcessedImageSourceSet(imageSrc);
  const screenClass = useScreenClass();
  const isExtraSmall = screenClass === "xs";

  if (isFluidImage && processedImageSrc)
    return (
      <FluidImage
        src={processedImageSrc?.split(" ")[0]}
        srcSet={processedImageSrc}
        alt={altOverride}
        data-testid={testId}
        {...imageOverrideProps}
      />
    );

  if (isBannerLogo && processedImageSrc)
    return (
      <ResponsiveImage
        src={processedImageSrc?.split(" ")[0]}
        srcSet={processedImageSrc}
        alt={altOverride}
        data-testid={testId}
        {...imageOverrideProps}
        mb={"3"}
        style={{
          height: isDoubleBanner || isExtraSmall ? "60px" : "80px",
        }}
      />
    );
  if (processedImageSrc) {
    return (
      <img
        src={processedImageSrc?.split(" ")[0]}
        srcSet={processedImageSrc}
        alt={altOverride}
        style={{ display: "inline-block" }}
        data-testid={testId}
        {...imageOverrideProps}
      />
    );
  }
  return <></>;
};
